import s from './NotFound.module.css';

const NotFound = () => {
  return <div className={s.container}>No item found</div>;
};

export { NotFound };
